import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InviteState {
  invitor: string | null;
  lobbyId: string | null;
}

const initialState: InviteState = {
  invitor: null,
  lobbyId: null
};

export const inviteSlice = createSlice({
  name: "invite",
  initialState,
  reducers: {
    invite: (
      state,
      action: PayloadAction<{ invitor: string; lobbyId: string }>
    ) => {
      state.invitor = action.payload.invitor;
      state.lobbyId = action.payload.lobbyId;
    },
    dismiss: (state) => {
      state.invitor = null;
      state.lobbyId = null;
    }
  }
});

export const { invite, dismiss } = inviteSlice.actions;
export default inviteSlice.reducer;
